import { LocalizedEnum, LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { AvailabilityBlock } from '@mews-commander/data-access';
import { Typography, Body, Stack } from '@optimus-web/core';

interface PickupDistributionInfoProps {
    pickupDistribution: AvailabilityBlock['pickupDistribution'];
}

export const PickupDistributionInfo = ({ pickupDistribution }: PickupDistributionInfoProps) => (
    <Stack vertical>
        <Typography textStyle="bodyMediumStrong" variant="secondary" as="div">
            <LocalizedText textKey={TextKey.PickupDistribution} />
        </Typography>
        <Body whiteSpace="nowrap" ellipsis>
            <LocalizedEnum prefix="PickupDistribution" value={pickupDistribution} />
        </Body>
    </Stack>
);
